export const ERROR_PLUGIN_SET = "ERROR_PLUGIN_SET";

/**
 * Sets errored plugins
 */
export const setPluginErrors = contentObject => {
  return (dispatch) => {
    dispatch({
      type: ERROR_PLUGIN_SET,
      payload: contentObject,
    });
  };
}